import type { Dropdown, NamedInternalLink, RelativeLink } from '../../pages/api/types';
import type { KeyedArray } from '../sanity/types';
import Logo from './Logo';
import MegaMenu from './MegaMenu';
import MiniCart from './MiniCart';
import MyPageLink from './MyPageLink';
import SearchBox from './SearchBox';
import * as style from './StickyHeader.module.css';

export default function StickyHeader({ links }: { links: KeyedArray<RelativeLink | NamedInternalLink | Dropdown> }) {
    return (
        <div className={style.stickyHeader}>
            <div className="section__inner-container">
                <div className={style.logoSearchMenu}>
                    <Logo />

                    <div className={style.search}>
                        <SearchBox />
                    </div>

                    <div className={style.menu}>
                        <MyPageLink />
                        <MiniCart />
                        <MegaMenu links={links} />
                    </div>
                </div>
            </div>
        </div>
    );
}
